/* Hilltop Nord — keep hero "shop the look" hotspots glued to the PHOTO, not the box.
   The hero image is object-fit: cover, so each viewport shows a different crop;
   the x/y sliders are % of the photo itself and this maps them into the visible crop.
   Falls back to plain container-% when the hero shows video or two media slots. */

const fallbackStyle = (spot) => {
  spot.style.left = `calc(${spot.dataset.hnX || 50}% - var(--button-size) / 2)`;
  spot.style.top = `calc(${spot.dataset.hnY || 50}% - var(--button-size) / 2)`;
  spot.style.visibility = '';
};

function place(container) {
  const grid = container.closest('.hero__media-grid');
  if (!grid) return;
  const spots = [...container.querySelectorAll('[data-hn-x]')];
  if (!spots.length) return;

  const imgs = [...grid.querySelectorAll('img.hero__media')].filter(
    (i) => i.offsetWidth > 0 && i.offsetHeight > 0
  );
  if (imgs.length !== 1) {
    spots.forEach(fallbackStyle);
    return;
  }
  const img = imgs[0];
  const iw = img.naturalWidth;
  const ih = img.naturalHeight;
  if (!iw || !ih) return; // image not loaded yet — load listener will re-run

  const box = img.getBoundingClientRect();
  const cbox = container.getBoundingClientRect();
  if (!box.width || !cbox.width) return;

  // object-fit: cover, object-position: center — the drawn image size and crop offset
  const scale = Math.max(box.width / iw, box.height / ih);
  const drawnW = iw * scale;
  const drawnH = ih * scale;
  const cropX = (drawnW - box.width) / 2;
  const cropY = (drawnH - box.height) / 2;

  const designMode = window.Shopify && window.Shopify.designMode;

  for (const spot of spots) {
    const relX = (parseFloat(spot.dataset.hnX) || 0) / 100;
    const relY = (parseFloat(spot.dataset.hnY) || 0) / 100;
    let px = relX * drawnW - cropX + (box.left - cbox.left);
    let py = relY * drawnH - cropY + (box.top - cbox.top);

    const half = (spot.offsetWidth || 36) / 2;
    const outside = px < -half || px > cbox.width + half || py < -half || py > cbox.height + half;
    if (outside && designMode) {
      // keep the dot reachable in the theme editor instead of vanishing off-crop
      px = Math.min(Math.max(px, half), cbox.width - half);
      py = Math.min(Math.max(py, half), cbox.height - half);
    }
    spot.style.left = `${px - half}px`;
    spot.style.top = `${py - half}px`;
    spot.style.visibility = outside && !designMode ? 'hidden' : '';
  }
}

const wired = new WeakSet();

function init(root) {
  const scope = root instanceof Element || root instanceof Document ? root : document;
  scope.querySelectorAll('.hn-hero-hotspots').forEach((container) => {
    if (wired.has(container)) return;
    wired.add(container);
    const grid = container.closest('.hero__media-grid');
    if (!grid) return;
    const run = () => requestAnimationFrame(() => place(container));
    new ResizeObserver(run).observe(grid);
    grid.querySelectorAll('img.hero__media').forEach((img) => {
      img.addEventListener('load', run); // also refires if <picture> swaps sources
    });
    run();
  });
}

init(document);
// theme editor re-renders the section on every setting change
document.addEventListener('shopify:section:load', (e) => init(e.target));
